module.exports = __webpack_public_path__ + "img/youtube.adab0b7d.svg";